import api from './axios'

/**
 * Get all trainers with filters
 * @param {object} params - Filter parameters
 * @returns {Promise<{data: Array, pagination: object}>}
 */
export const getTrainers = async (params = {}) => {
  const response = await api.get('/trainers', { params })
  return response.data
}

/**
 * Get single trainer by ID
 * @param {number} id 
 * @returns {Promise<object>}
 */
export const getTrainer = async (id) => {
  const response = await api.get(`/trainers/${id}`)
  return response.data
}

/**
 * Get trainer with full details
 * @param {number} id 
 * @returns {Promise<object>}
 */
export const getTrainerFull = async (id) => {
  const response = await api.get(`/trainers/${id}/full`)
  return response.data
}

/**
 * Create new trainer
 * @param {object} trainerData 
 * @returns {Promise<object>}
 */
export const createTrainer = async (trainerData) => {
  const response = await api.post('/trainers', trainerData)
  return response.data
}

/**
 * Update trainer
 * @param {number} id 
 * @param {object} trainerData 
 * @returns {Promise<object>}
 */
export const updateTrainer = async (id, trainerData) => {
  const response = await api.put(`/trainers/${id}`, trainerData)
  return response.data
}

/**
 * Delete trainer
 * @param {number} id 
 * @returns {Promise<void>}
 */
export const deleteTrainer = async (id) => {
  const response = await api.delete(`/trainers/${id}`)
  return response.data
}

/**
 * Get trainer's teams
 * @param {number} id 
 * @returns {Promise<Array>}
 */
export const getTrainerTeams = async (id) => {
  const response = await api.get(`/trainers/${id}/teams`)
  return response.data
}

/**
 * Get trainer's contracts
 * @param {number} id 
 * @returns {Promise<Array>}
 */
export const getTrainerContracts = async (id) => {
  const response = await api.get(`/trainers/${id}/contracts`)
  return response.data
}